import React from 'react';
import { Card, CardContent } from '@mui/material';
import { DescriptionSection } from './DescriptionSection';
import { EmailSection } from './EmailSection';

// Description and the email action. Priority, category and people are shown
// by TaskFacts in the header; renders nothing when there is nothing to say.
export function TaskInfoCard({ task, sx }) {
  const hasDescription = Boolean(task.description?.trim());
  if (!hasDescription && !task.send_email) return null;

  return (
    <Card sx={sx}>
      <CardContent>
        {hasDescription && <DescriptionSection task={task} />}
        {task.send_email && <EmailSection task={task} divider={hasDescription} />}
      </CardContent>
    </Card>
  );
}

export default TaskInfoCard;
